import { render, staticRenderFns } from "./scoring.vue?vue&type=template&id=3c236735&scoped=true"
import script from "./scoring.vue?vue&type=script&lang=js"
export * from "./scoring.vue?vue&type=script&lang=js"
import style0 from "./scoring.vue?vue&type=style&index=0&id=3c236735&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c236735",
  null
  
)

export default component.exports